// extracted by mini-css-extract-plugin
export default {"buttons":"DeleteCategoryModal_buttons__ff8hg","errorMessage":"DeleteCategoryModal_errorMessage__FXKvV"};